import { Component } from '@angular/core';

@Component({
    selector: 'app-partner-terms',
    templateUrl: './partner-terms.component.html',
    styleUrl: './partner-terms.component.scss',
    standalone: false
})
export class PartnerTermsComponent {

}
